export const aboutContent = {
  hero: {
    text: "Earth Rights Business is as much about spiritual regeneration as it is about soil regeneration"
  },
  why: {
    title: "There's Too Much Money and Not Enough Value",
    text: "Money became abstract. We forgot where wealth actually comes from. The soil doesn't have a voice in business. It doesn't sit at the table where decisions are made. Meanwhile, it degrades—and with it, our food, our health, our future.",
    quote: "Money is make believe. We believe making soil rich is worth money."
  },
  reframe: {
    quote: "A Movement That Speaks for the Earth",
    text: "ERB gives soil a seat at the table through the power of collective consumer voice. We're not a charity. We're not a corporation. We're a MOVEMENT—a growing group of people who believe that how we spend money should regenerate, not deplete.\n\n\"Our tokenized alphabet symbolizes the power of a unified voice for the general brand of Earth's soil.\"\n\n\"Giving Earth Rights is not about authority. It's about having self respect with standards based on the awareness that the future nutritionally resides in the soil.\""
  },
  community: {
    title: "Decentralized Down to the Dirt",
    text: "• Local maximalism — supporting regenerative farms in your community\n• Horizontal outreach — consumer-driven growth, not top-down marketing\n• Vertical integration — from global message to local soil\n\n\"The local regenerative farms in the communities of our asset holders are the actual brands our meritocracy of messaging connects to in tangible reality.\"",
    accent: "The only thing centralized about our community is our shared frequency of abundance and reverence for life."
  },
  closing: {
    quote: "Because being open for service gives you the keys to become the vehicle abundance wants to drive",
    description: "Join the movement"
  }
};